import { TranslatableText, WithFieldController } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { translationKeys } from './translations';

type PassportValidToFieldProps = WithFieldController<unknown> & {
   readonly label?: TranslatableText;
};

export const PassportValidToField = (props: PassportValidToFieldProps): JSX.Element => {
   return (
      <DatePicker
         testId={'passportValidTo'}
         controller={props.controller}
         defaultValue={null}
         dayValidators={'dayBeforeToday'}
         label={props.label || translationKeys.passportValidTo.label}
         withNavigationArrows
      />
   );
};
